import { get, post, postJson, put, deleteApi, deleteApiJson } from '../axios'


// 保存分组
export const saveGroup  = p => postJson(`/ware/saveGroup`,p);

// 删除分组
export const delSkuGroup = p => deleteApi(`/ware/delSkuGroup/${p}`);

// 删除分组下的sku
export const removeSkuList = p => deleteApiJson(`/ware/removeSkuList`, p);

// 查询分组下所有商品
export const getSkuListByGroup = p => get(`/ware/getSkuListByGroup/${p}`);

// 添加Sku至分组(输入skuId)
export const addSkuByType = p => postJson(`/ware/addSkuByType`, p);

// 分页查询sku分组列表
export const getGroupPage  = p => get(`/ware/getGroupPage`,p);